<template><section><h3>深潜救生艇水下航行流体仿真系统</h3>
<h4>背景介绍：</h4>
<p>随着潜艇数量的增加，潜艇作战半径的增大及海域的复杂化，潜艇发生的事故也逐年增加。深潜救生艇是一种人工操纵的可在水下机动航行的潜水装置，是潜艇救生和保障的主要手段。然而，深海环境具有高压、低温、强腐蚀性以及复杂的流体动力学特性等特点。其中，深海流体的运动状态复杂多变，受到多种因素的总和影响。海水温度和盐度的分布不均会导致海水密度差异，进而引发热盐环流；海风的吹拂则会形成风生海流，其强度和方向随季节和地理位置的变化显著。这些复杂的流体因素使得深潜救生艇在水下航行时面临诸多挑战。例如，海流的存在会使深潜救生艇的实际航行轨迹偏离预定航线，增加航行的不确定性和风险；强流作用下，深潜救生艇可能会承受过大的水动力载荷，对其结构强度和稳定性构成威胁；同时，复杂的流场还会影响深潜救生艇的推进效率和操作性能，影响其作业任务的顺利完成。</p>
<p>为了应对这些挑战，本项目拟设计一个无人潜水器水下航行流体仿真系统。该系统具有轻量化和流固耦合的特征，能在浏览器/手机/平板等设备上进行实时仿真计算与可视化。本系统的轻量化特征包含计算与渲染两个方面：在计算方面，本系统采用基于粒子的PBF（Position-Based Fluids）算法，实现流体运动方程的轻量化求解；在渲染方面，本系统基于屏幕空间的流体渲染（Screen Space Fluid Rendering, SSFR），确保移动端的流体实时渲染。本系统的流固耦合特征在于采用基于探针的耦合策略（Probe-Based Coupling），在潜水器表面布设探针，以采样流体的速度与压力，进而计算出作用于壳体的合力与力矩，驱动潜水器航行姿态的更新。上述算法涉及大量流体粒子之间的邻近搜索与约束求解，以及探针对粒子场的实时采样计算，在移动端CPU上可能难以满足实时渲染要求，因此本系统基于Vulkan或 OpenGL等图形/并行计算API，完成系统核心算法的GPU并行实现。</p>
<h4>项目要求：</h4>
<ol>
<li>
<p>实现 GPU 实时流体求解</p>
<ul>
<li>完成 PBF（Position-Based Fluids）算法的 GPU 并行实现，包括空间哈希邻居搜索、密度约束投影与边界处理，在桌面浏览器上支持 10 万级粒子以不低于 60fps 实时求解，移动端不低于 30fps。</li>
</ul>
</li>
<li>
<p>实现探针式流固耦合</p>
<ul>
<li>在潜水器壳体表面按“均匀布设+曲率加密”策略布置探针，采样流场速度与压力并归约为合力与力矩，驱动六自由度刚体积分更新潜水器姿态，耦合计算不成为整体帧率瓶颈。</li>
</ul>
</li>
<li>
<p>实现 SSFR 流体渲染</p>
<ul>
<li>完成粒子场到屏幕空间连续水面的渲染管线（深度投影、双向滤波平滑、法线重建、折射/反射/泡沫着色），在移动端实时输出真实感水体画面。</li>
</ul>
</li>
<li>
<p>完成系统集成与典型任务</p>
<ul>
<li>打通“参数配置—流体求解—流固耦合—渲染显示”全链路，支持至少四类典型用户任务，全程在浏览器中运行、无需安装。</li>
</ul>
</li>
</ol>
</section></template><script>export default {components:{}}</script>